const CONFIG = {
  API_URI: "https://api.cats.dmkent.net",
  VERSION: VERSION,
  BASENAME: BASENAME,
};
export default CONFIG;
